import { jsx as _jsx } from "react/jsx-runtime";
import { ImageThumb } from '@wit-support/ui';
import { previewSrc } from '../api.js';
/**
 * Картинка-превью файла или поста через admin-api (`previewUrl` ответа) —
 * `ImageThumb` кита с адресом через шлюз. Нет превью или оно не загрузилось —
 * значок типа: видео, картинка или «нет картинки» у поста.
 */
export function MediaPreview({ previewUrl, kind, label, size = 'sm', }) {
    return _jsx(ImageThumb, { src: previewSrc(previewUrl), kind: kind, label: label, size: size });
}
//# sourceMappingURL=media-preview.js.map